import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { InjectedConnector } from "./chunk-P4NRLOY7.js";
import { ConnectorNotFoundError } from "./chunk-UGBGYVBH.js";
import "./chunk-OQILYQDO.js";
import { __privateAdd, __privateGet, __privateSet } from "./chunk-W65LBPLT.js";

// src/metaMask.ts
import { ResourceUnavailableRpcError, UserRejectedRequestError, getAddress } from "viem";
var _UNSTABLE_shimOnConnectSelectAccount;
var MetaMaskConnector = class extends InjectedConnector {
  constructor() {
    let {
      chains,
      options: options_
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const options = _objectSpread({
      name: "MetaMask",
      shimDisconnect: true,
      getProvider() {
        function getReady(ethereum2) {
          const isMetaMask = !!(ethereum2 !== null && ethereum2 !== void 0 && ethereum2.isMetaMask);
          if (!isMetaMask) return;
          if (ethereum2.isBraveWallet && !ethereum2._events && !ethereum2._state) return;
          if (ethereum2.isApexWallet) return;
          if (ethereum2.isAvalanche) return;
          if (ethereum2.isBitKeep) return;
          if (ethereum2.isBlockWallet) return;
          if (ethereum2.isCoin98) return;
          if (ethereum2.isFordefi) return;
          if (ethereum2.isMathWallet) return;
          if (ethereum2.isOkxWallet || ethereum2.isOKExWallet) return;
          if (ethereum2.isOneInchIOSWallet || ethereum2.isOneInchAndroidWallet) return;
          if (ethereum2.isOpera) return;
          if (ethereum2.isPortal) return;
          if (ethereum2.isRabby) return;
          if (ethereum2.isDefiant) return;
          if (ethereum2.isTokenPocket) return;
          if (ethereum2.isTokenary) return;
          if (ethereum2.isZeal) return;
          if (ethereum2.isZerion) return;
          return ethereum2;
        }
        if (typeof window === "undefined") return;
        const ethereum = window.ethereum;
        if (ethereum !== null && ethereum !== void 0 && ethereum.providers) return ethereum.providers.find(getReady);
        return getReady(ethereum);
      }
    }, options_);
    super({
      chains,
      options
    });
    this.id = "metaMask";
    this.shimDisconnectKey = "".concat(this.id, ".shimDisconnect");
    __privateAdd(this, _UNSTABLE_shimOnConnectSelectAccount, void 0);
    __privateSet(this, _UNSTABLE_shimOnConnectSelectAccount, options.UNSTABLE_shimOnConnectSelectAccount);
  }
  async connect() {
    let {
      chainId
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      var _this$options, _this$storage, _this$options2, _this$storage2;
      const provider = await this.getProvider();
      if (!provider) throw new ConnectorNotFoundError();
      if (provider.on) {
        provider.on("accountsChanged", this.onAccountsChanged);
        provider.on("chainChanged", this.onChainChanged);
        provider.on("disconnect", this.onDisconnect);
      }
      this.emit("message", {
        type: "connecting"
      });
      let account = null;
      if (__privateGet(this, _UNSTABLE_shimOnConnectSelectAccount) && (_this$options = this.options) !== null && _this$options !== void 0 && _this$options.shimDisconnect && !((_this$storage = this.storage) !== null && _this$storage !== void 0 && _this$storage.getItem(this.shimDisconnectKey))) {
        account = await this.getAccount().catch(() => null);
        const isConnected = !!account;
        if (isConnected) try {
          await provider.request({
            method: "wallet_requestPermissions",
            params: [{
              eth_accounts: {}
            }]
          });
          account = await this.getAccount();
        } catch (error) {
          if (this.isUserRejectedRequestError(error)) throw new UserRejectedRequestError(error);
          if (error.code === new ResourceUnavailableRpcError(error).code) throw error;
        }
      }
      if (!account) {
        const accounts = await provider.request({
          method: "eth_requestAccounts"
        });
        account = getAddress(accounts[0]);
      }
      let id = await this.getChainId();
      let unsupported = this.isChainUnsupported(id);
      if (chainId && id !== chainId) {
        const chain = await this.switchChain(chainId);
        id = chain.id;
        unsupported = this.isChainUnsupported(id);
      }
      if ((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.shimDisconnect) (_this$storage2 = this.storage) === null || _this$storage2 === void 0 || _this$storage2.setItem(this.shimDisconnectKey, true);
      return {
        account,
        chain: {
          id,
          unsupported
        },
        provider
      };
    } catch (error) {
      if (this.isUserRejectedRequestError(error)) throw new UserRejectedRequestError(error);
      if (error.code === -32002) throw new ResourceUnavailableRpcError(error);
      throw error;
    }
  }
};
_UNSTABLE_shimOnConnectSelectAccount = new WeakMap();
export { MetaMaskConnector };